import programTypes from './constants';

const hrefs = {
	childRoutes: {
		// HEP or PT routes
		homeExercisePlan: `/homeExercisePlan`,
		hepPreviouslyAssigned: `/hepPreviouslyAssigned`,
		exerciseDetails: `/exerciseDetails`,
		// Coach routes
		coachingPreviouslyAssigned: `/coachingPreviouslyAssigned`,
		// OT plan routes
		occupationalTherapyPlan: `/occupationalTherapyPlan`,
		occupationalTherapyPreviouslyAssigned: `/occupationalTherapyPreviouslyAssigned`,
		occupationalTherapyExerciseDetails: `/occupationalTherapyExerciseDetails`,
		// MSK fitness recovery routes
		virtualMSKPreviouslyAssigned: `/virtualMSKPreviouslyAssigned`,
		virtualMSKExerciseDetails: `/virtualMSKExerciseDetails`,
	},
};

export default hrefs;

export const planRoutes = programType => {
	switch (programType) {
		case programTypes.physicalTherapy:
			return hrefs.childRoutes.homeExercisePlan;
		case programTypes.occupationalTherapy:
			return hrefs.childRoutes.occupationalTherapyPlan;
		default:
			return hrefs.childRoutes.homeExercisePlan; // Backward compatability
	}
};

export const previouslyAssignedRoutes = programType => {
	switch (programType) {
		case programTypes.physicalTherapy:
			return hrefs.childRoutes.hepPreviouslyAssigned;
		case programTypes.occupationalTherapy:
			return hrefs.childRoutes.occupationalTherapyPreviouslyAssigned;
		case programTypes.virtualMSK:
			return hrefs.childRoutes.virtualMSKPreviouslyAssigned;
		default:
			return hrefs.childRoutes.hepPreviouslyAssigned; // Backward compatability
	}
};

export const exerciseDetailRoutes = programType => {
	switch (programType) {
		case programTypes.physicalTherapy:
			return hrefs.childRoutes.exerciseDetails;
		case programTypes.occupationalTherapy:
			return hrefs.childRoutes.occupationalTherapyExerciseDetails;
		case programTypes.virtualMSK:
			return hrefs.childRoutes.virtualMSKExerciseDetails;
		default:
			return hrefs.childRoutes.exerciseDetails; // Backward compatability
	}
};
